"use strict";

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _toConsumableArray = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var eth_sdk_1 = require("eth-sdk");

var constants_1 = require("../constants");

var utils_1 = require("../utils");

var BatchModule = /*#__PURE__*/function () {
  function BatchModule(sdk) {
    _classCallCheck(this, BatchModule);

    this.sdk = sdk;
    this.state$ = new BatchModule.State();
    this.options = {
      estimationGasPrice: eth_sdk_1.toWei(1, eth_sdk_1.Units.Gwei),
      estimationRefundAmount: new bn_js_1.default(1)
    }; //
  }

  _createClass(BatchModule, [{
    key: "initialize",
    value: function initialize() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var relayer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                relayer = this.sdk.clients.relayer;
                _context.next = 3;
                return relayer.getBatchModuleOptions();

              case 3:
                this.options = _context.sent;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "addToBatch",
    value: function addToBatch(creator) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var account, result, nonce, _result, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                account = this.sdk.modules.account;
                result = this.state;

                if (result) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return account.verifyNonce();

              case 5:
                nonce = _context2.sent;
                result = {
                  nonce: nonce,
                  data: []
                };
                _context2.next = 12;
                break;

              case 9:
                nonce = this.state.nonce;
                nonce = nonce.addn(1);
                result = Object.assign(Object.assign({}, result), {
                  nonce: nonce
                });

              case 12:
                _result = result, data = _result.data;

                if (!(data.length === BatchModule.MAX_SIZE)) {
                  _context2.next = 15;
                  break;
                }

                throw new Error('batch is full');

              case 15:
                data = [].concat(_toConsumableArray(data), [creator({
                  nonce: nonce,
                  account: account.address
                })]);
                result = {
                  nonce: nonce,
                  data: data
                };
                this.state$.next(result);
                return _context2.abrupt("return", result);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "estimateBatch",
    value: function estimateBatch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var result, refundToken, _this$options, estimationRefundAmount, estimationGasPrice, _yield$this$buildEsti, to, data, _this$sdk, relayer, block, estimation, gas, gasPrice, refundAmount;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                result = this.state;

                if (result) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('batch is empty');

              case 3:
                refundToken = options.refundToken;
                refundToken = eth_sdk_1.toChecksumAddress(refundToken);

                if (!refundToken) {
                  refundToken = eth_sdk_1.ZERO_ADDRESS;
                }

                _this$options = this.options, estimationRefundAmount = _this$options.estimationRefundAmount, estimationGasPrice = _this$options.estimationGasPrice;
                _context3.next = 9;
                return this.buildEstimateTransactionOptions(Object.assign(Object.assign({}, result), {
                  refundToken: refundToken,
                  refundAmount: estimationRefundAmount,
                  gasPrice: estimationGasPrice
                }));

              case 9:
                _yield$this$buildEsti = _context3.sent;
                to = _yield$this$buildEsti.to;
                data = _yield$this$buildEsti.data;
                _this$sdk = this.sdk, relayer = _this$sdk.clients.relayer, block = _this$sdk.modules.block;
                _context3.next = 15;
                return relayer.estimateTransaction({
                  to: to,
                  data: data
                });

              case 15:
                estimation = _context3.sent;
                gas = estimation.gas;
                gasPrice = block.gasPrice;
                refundAmount = gasPrice.muln(gas);

                if (!(refundToken !== eth_sdk_1.ZERO_ADDRESS)) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 22;
                return relayer.calcSupportedTokenAmount({
                  address: refundToken,
                  amount: refundAmount
                });

              case 22:
                refundAmount = _context3.sent;

              case 23:
                result = Object.assign(Object.assign({}, result), {
                  estimation: estimation,
                  gasPrice: gasPrice,
                  refundToken: refundToken,
                  refundAmount: refundAmount
                });
                this.state$.next(result);
                return _context3.abrupt("return", result);

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "submitBatch",
    value: function submitBatch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var state, _yield$this$buildEsti2, to, data, _this$sdk2, relayer, notification, _state, gasPrice, estimation, key;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = this.state;

                if (state) {
                  _context4.next = 3;
                  break;
                }

                throw new Error('batch is empty');

              case 3:
                if (state.estimation) {
                  _context4.next = 5;
                  break;
                }

                throw new Error('batch is not estimated');

              case 5:
                if (options.gasPrice && options.gasPrice.gt(new bn_js_1.default(0))) {
                  state = Object.assign(Object.assign({}, state), {
                    gasPrice: options.gasPrice
                  });
                }

                _context4.next = 8;
                return this.buildEstimateTransactionOptions(state);

              case 8:
                _yield$this$buildEsti2 = _context4.sent;
                to = _yield$this$buildEsti2.to;
                data = _yield$this$buildEsti2.data;
                _this$sdk2 = this.sdk, relayer = _this$sdk2.clients.relayer, notification = _this$sdk2.modules.notification;
                _state = state, gasPrice = _state.gasPrice, estimation = _state.estimation;
                _context4.next = 15;
                return relayer.relayTransaction(Object.assign({
                  to: to,
                  data: data,
                  gasPrice: gasPrice
                }, estimation));

              case 15:
                key = _context4.sent;
                this.state$.reset();
                notification.subscribe(relayer.subscribeRelayedTransaction(key).map(function (payload) {
                  return {
                    type: constants_1.NotificationTypes.RelayedTransactionUpdated,
                    payload: payload
                  };
                }));
                return _context4.abrupt("return", key);

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "buildEstimateTransactionOptions",
    value: function buildEstimateTransactionOptions(state) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this$sdk3, accountRegistry, authKey, chainId, refundToken, refundAmount, estimationRefundAmount, gasPrice, innerData, msgSig, to, messageHash, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$sdk3 = this.sdk, accountRegistry = _this$sdk3.contracts.accountRegistry, authKey = _this$sdk3.modules.authKey, chainId = _this$sdk3.state.chainId;
                refundToken = state.refundToken, refundAmount = state.refundAmount;
                estimationRefundAmount = this.options.estimationRefundAmount;

                if (estimationRefundAmount.eqn(0)) {
                  refundToken = eth_sdk_1.ZERO_ADDRESS;
                  refundAmount = new bn_js_1.default(0);
                }

                gasPrice = state.gasPrice, innerData = state.data;
                msgSig = accountRegistry.getMethodSignature('relayAccountOwnerCall');
                to = accountRegistry.address;
                messageHash = eth_sdk_1.soliditySha3(to, chainId, msgSig, eth_sdk_1.concatHex.apply(eth_sdk_1, _toConsumableArray(innerData)), refundToken, refundAmount, gasPrice);
                _context5.t0 = accountRegistry;
                _context5.t1 = refundToken;
                _context5.t2 = refundAmount;
                _context5.t3 = innerData;
                _context5.next = 14;
                return authKey.signPersonalMessage(messageHash);

              case 14:
                _context5.t4 = _context5.sent;
                _context5.t5 = {
                  refundToken: _context5.t1,
                  refundAmount: _context5.t2,
                  data: _context5.t3,
                  signature: _context5.t4
                };
                data = _context5.t0.buildRelayAccountOwnerCallData.call(_context5.t0, _context5.t5);
                return _context5.abrupt("return", {
                  to: to,
                  data: data
                });

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "state",
    get: function get() {
      return this.state$.getValue();
    }
  }]);

  return BatchModule;
}();

exports.BatchModule = BatchModule;
BatchModule.MAX_SIZE = 5;

(function (BatchModule) {
  var State = /*#__PURE__*/function (_utils_1$StateSubject) {
    _inherits(State, _utils_1$StateSubject);

    var _super = _createSuper(State);

    function State() {
      _classCallCheck(this, State);

      return _super.call(this);
    }

    return State;
  }(utils_1.StateSubject);

  BatchModule.State = State;
})(BatchModule = exports.BatchModule || (exports.BatchModule = {}));